<template>
    <v-card flat>
        <v-card-title>
            Listado
            <v-spacer></v-spacer>
        </v-card-title>
        <v-data-table calculate-widths :headers="list_header" :items="formulas" loading-text="Loading... Please wait"
            item-key="cod_formula" show-expand :single-expand=true :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            disable-pagination :hide-default-footer="true" :server-items-length="totalFormulas" :loading="loading">

            <template v-slot:item.cod_formula="{ item }">
                <router-link :to="'/formulas/' + item.cod_formula">{{
                    item.cod_formula
                }}</router-link>
            </template>

            <template v-slot:item.precio="{ item }">
                <v-chip>{{ item.precio }} €/Kg</v-chip>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <v-row>
                        <v-col>
                            <v-card-title>Bases</v-card-title>
                            <div class="text--primary" v-for="base in item.bases" :key="base.id" fluid>
                                {{ base.cod_base.cod_base }} ({{ base.cod_base.descripcion }})
                            </div>
                        </v-col>
                        <v-col>
                            <v-card-title>Aditivos</v-card-title>
                            <div class="text--primary" v-for="aditivo in item.aditivos" :key="aditivo.id" fluid>
                                {{ aditivo.cod_aditivo.cod_aditivo }} ({{ aditivo.cod_aditivo.descripcion }})
                            </div>
                        </v-col>
                        <v-col>
                            <v-card-title>Color</v-card-title>
                            <v-card-text fluid>{{ item.color }}</v-card-text>
                        </v-col>
                        <v-col>
                            <v-card-title>Aplicaciones</v-card-title>
                            <v-card-text fluid v-if="item.aplicacion.length > 0">
                                <div class="text--primary" v-for="aplica in item.aplicacion" :key="aplica.id">
                                    {{ aplica.id_aplicacion.nombre }}
                                </div>
                            </v-card-text>
                            <v-card-text fluid v-else>No existen.</v-card-text>
                        </v-col>
                    </v-row>
                </td>
            </template>

            <template v-slot:item.fda="{ item }">
                <v-simple-checkbox v-model="item.fda" disabled></v-simple-checkbox>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="editFormula(item.cod_formula)">mdi-pencil</v-icon>
                <v-icon small @click="showDeleteDialog(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>

        <v-col cols="12" sm="12">
            <v-row align="center" justify="center">
                <v-col cols="8">
                    <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right"
                        prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
                </v-col>

                <v-col cols="2">
                    <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
                        @change="handlePageSizeChange"></v-select>
                </v-col>

                <v-col cols="2">
                    <div>Items total: {{ this.totalFormulas }}</div>
                </v-col>
            </v-row>
        </v-col>

        <v-dialog v-model="dialogDelete" persistent max-width="400">
            <v-card>
                <v-card-title class="text-h5">
                    {{ itemToDelete.cod_formula }}
                </v-card-title>
                <v-card-text>¿Estás seguro de querer borrar la fórmula?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="dialogDelete = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" text @click="deleteFormula(itemToDelete.cod_formula)">
                        Borrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import FormulasDataService from "@/services/FormulasDataService";
export default {
    name: "FormulasList",
    data() {
        return {
            formulas: [],
            sortBy: 'cod_formula',
            sortDesc: false,
            list_header: [
                { text: 'CODIGO', value: 'cod_formula' },
                { text: 'DESCRIPCIÓN', value: 'descripcion' },
                { text: 'DUREZA (post)', value: 'dureza', sortable: false },
                { text: 'TEMP.SERVICIO', value: 'temp_servicio', sortable: false },
                { text: 'FDA', value: 'fda' },
                { text: '€/Kg', value: 'precio' },
                { text: "Actions", value: "actions", sortable: false },
            ],
            dialogDelete: false,
            itemToDelete: {},
            loading: true,

            totalFormulas: 0,
            totalPages: 0,
            page: 1,
            pageSize: 10,
            pageSizes: [5, 10, 20],
        }
    },
    watch: {
        sortBy: {
            handler() {
                this.loading = true;
                this.page = 1;
                this.retrieveFormulas();
            },
        },
        sortDesc: {
            handler() {
                this.loading = true;
                this.page = 1;
                this.retrieveFormulas();
            },
        },
    },
    methods: {
        handlePageChange(value) {
            this.page = value;
            this.retrieveFormulas();
        },
        handlePageSizeChange(size) {
            this.pageSize = size;
            this.page = 1;
            this.retrieveFormulas();
        },
        retrieveFormulas() {
            this.loading = true;

            const pageparams = new URLSearchParams();
            pageparams.append('page', this.page);
            pageparams.append('pageSize', this.pageSize);
            pageparams.append('sort', this.sortBy);
            pageparams.append('desc', this.sortDesc);

            FormulasDataService.getPage(pageparams)
                .then((response) => {
                    // console.log("FORMULAS"); console.log(response.data.formulas);
                    this.formulas = response.data.formulas.map(this.getDisplayFormula);
                    this.totalFormulas = response.data.total;
                    this.totalPages = parseInt(this.totalFormulas / this.pageSize, 10);
                    this.loading = false;
                })
                .catch((e) => {
                    console.log(e);
                    this.loading = false;
                });
        },
        editFormula(id) {
            this.$router.push({ name: "FormulaId", params: { id: id } });
        },
        deleteFormula(id) {
            FormulasDataService.delete(id)
                .then(() => {
                    this.retrieveFormulas();
                    this.dialogDelete = false
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        getDisplayFormula(formula) {
            let str_dureza = formula.sinpostcurado_dureza;
            if (formula.postcurado_dureza > 0) {
                str_dureza += " (" + formula.postcurado_dureza + ")"
            }
            let ppc_total = 0.0
            var dict = new Object();

            for (const base of formula.formula_base) {
                for (const proveedor of base.cod_base.proveedor_base) {
                    ppc_total += base.ppc;
                    dict[base.cod_base.cod_base] = {};
                    dict[base.cod_base.cod_base].ppc = base.ppc;
                    dict[base.cod_base.cod_base].precio = proveedor.precio;
                }
            }

            for (const aditivo of formula.formula_aditivo) {
                for (const proveedor of aditivo.cod_aditivo.proveedor_aditivo) {
                    ppc_total += aditivo.ppc;
                    dict[aditivo.cod_aditivo.cod_aditivo] = {};
                    dict[aditivo.cod_aditivo.cod_aditivo].ppc = aditivo.ppc;
                    dict[aditivo.cod_aditivo.cod_aditivo].precio = proveedor.precio;
                }
            }

            let precio_total = 0.0;
            for (var key in dict) {
                var value = dict[key];
                precio_total += (value.ppc / ppc_total) * value.precio
            }

            return {
                cod_formula: formula.cod_formula,
                descripcion: formula.descripcion,
                color: formula.id_color ? formula.id_color.nombre + " (" + formula.id_color.ral + ") " + formula.id_color.referencia : "",
                bases: formula.formula_base,
                aditivos: formula.formula_aditivo,
                aplicacion: formula.formula_aplicacion,
                temp_servicio: formula.temp_servicio,
                fda: formula.fda,
                dureza: str_dureza,
                precio: precio_total.toFixed(2),
            };
        },
        showDeleteDialog(item) {
            this.itemToDelete = item
            this.dialogDelete = !this.dialogDelete
        },
    },
    mounted() {
        this.retrieveFormulas();
    }
};
</script>
